import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { deletePlayer } from '../../../actions/players.js'

import {Card, CardActions, CardContent, CardMedia, Button, Typography} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import ModeEditIcon from '@mui/icons-material/ModeEdit';


import useStyles from './styles.js'

import avatar from '../../../images/avatar-anonyme.png'
import { isAdminUser } from '../../../actions/auth.js'

const Player = ({ player, setCurrentId, reload }) => {
    const classes = useStyles();

    const dispatch = useDispatch()

    const teams = useSelector((state) => state.teams.filter(c => player.teams && player.teams.includes(c._id)))
  
    return (
        <Card className={classes.card}>
            <CardMedia className={classes.media} image={player.photoUrl || avatar} title={player.lastname + ' ' + player.firstname}/>

            <div className={classes.details}>
                <Typography variant="body2" color="textSecondary">{teams.length ?  teams.map((c, idx) => (idx===0 ? '' : ', ')+c.name) : "Aucune équipe"}</Typography>
            </div>
            <CardContent>
                <Typography className={classes.title} variant="h5" gutterBottom>{player.lastname} {player.firstname}</Typography>
            </CardContent>

            <CardActions className={classes.cardActions}>
            {isAdminUser() && <Button size="small" color="primary" onClick={() => {dispatch(deletePlayer(player._id)); reload()}}>
                    <DeleteIcon fontSize="small"/>
                    Supprimer
                </Button>}

                <Button size="small" color="primary" onClick={() => {setCurrentId(player._id)}}>
                    <ModeEditIcon fontSize="small" />
                    Editer
                </Button> 
            </CardActions>
        </Card>
    )
}

export default Player